export const appVersion = String(process.env.REACT_APP_VERSION);
export const googleReCaptchaSiteKey = '6LcuKm4aAAAAAF_TfkWYADF-KiiV6oqUVdglPap5';
